import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import { Transition } from 'react-transition-group';
import Box from "../Box";
import Layer from "../Layer";
import elementContains from "../Layer/elementContains";
import getViewportHeight from "../Layer/getViewportHeight";
import getViewportWidth from "../Layer/getViewportWidth";
var scrollbarWidth = 17; // Scrollbar widths are between 12px and 17px, depending on OS

var ModalLayer = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalLayer, _React$Component);

  var _super = _createSuper(ModalLayer);

  function ModalLayer() {
    var _this;

    _classCallCheck(this, ModalLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.content = void 0;
    _this.mountTimeout = void 0;
    _this.wash = void 0;

    _this.handleEnter = function () {
      /**
       * Attempt to apply focus to the content container after mount. This allows
       * us to listen for key events, tab into form elements, etc.
       *
       * If, upon mount, the document already has an active element that is
       * contained within the modal contents, there's nothing to do. This is
       * in place to preserve autofocus behavior on inputs.
       */
      _this.mountTimeout = setTimeout(function () {
        var content = _this.content;
        var activeElement = document.activeElement;

        if (content) {
          if (activeElement && elementContains(content, activeElement)) {
            return;
          }

          content.focus();
        } // Ensure that the wash is scrolled to the top.


        var wash = _this.wash;

        if (wash) {
          wash.scrollTop = 0;
        }
      }, 100);

      _this.htmlNode().classList.add('is-ModalLayer--active');
    };

    _this.handleExited = function () {
      _this.mountTimeout && clearTimeout(_this.mountTimeout);

      _this.htmlNode().classList.remove('is-ModalLayer--active');
    };

    _this.contentRef = function (node) {
      _this.content = node;
    };

    _this.washRef = function (node) {
      _this.wash = node;
    };

    _this.handleKeyDown = function (e) {
      var key = e.key;
      var onEscape = _this.props.onEscape;

      switch (key) {
        case 'Escape':
          if (onEscape) {
            e.preventDefault();
            onEscape();
          }

          break;

        default:
          break;
      }
    };

    _this.handleWashClick = function (e) {
      var clientX = e.clientX,
          target = e.target;
      var onWashClick = _this.props.onWashClick;
      var hasVerticalScroll = _this.content ? _this.content.scrollHeight > getViewportHeight() : null;
      var isOnScrollbar = hasVerticalScroll && clientX + scrollbarWidth >= getViewportWidth();

      if (!isOnScrollbar && target && target instanceof Node && _this.content && !elementContains(_this.content, target) && onWashClick) {
        e.preventDefault();
        onWashClick();
      }
    };

    return _this;
  }

  _createClass(ModalLayer, [{
    key: "componentWillUnmount",

    /**
     * In cases where we directly unmount the component without first transitioning
     * to `exited`, perform the same behavior.
     */
    value: function componentWillUnmount() {
      this.handleExited();
    }
  }, {
    key: "htmlNode",
    value: function htmlNode() {
      if (document.documentElement) {
        return document.documentElement;
      } // This is a little over the top since the top will be true for us always
      // but it makes flow happier.


      return document.querySelector('html') || document.createElement('html');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          shown = _this$props.shown,
          remaining = _objectWithoutProperties(_this$props, ["children", "className", "shown"]);

      return /*#__PURE__*/React.createElement(Transition, {
        appear: true,
        in: shown,
        mountOnEnter: true,
        onEnter: this.handleEnter,
        onExited: this.handleExited,
        timeout: 200,
        unmountOnExit: true
      }, function (status) {
        var classes = classNames('ModalLayer-container', className);
        var washClasses = classNames('ModalLayer-wash', "ModalLayer-wash--".concat(status));
        return /*#__PURE__*/React.createElement(Layer, _extends({}, remaining, {
          className: classes,
          trapFocus: true,
          returnFocus: true
        }), /*#__PURE__*/React.createElement(Box, {
          boxRef: _this2.washRef,
          className: washClasses,
          onMouseDown: _this2.handleWashClick
        }, /*#__PURE__*/React.createElement(Box, {
          "aria-modal": "true",
          className: "ModalLayer-contents",
          onKeyDown: _this2.handleKeyDown,
          tabIndex: "-1",
          boxRef: _this2.contentRef
        }, children)));
      });
    }
  }]);

  return ModalLayer;
}(React.Component);

export default ModalLayer;